module.exports = __webpack_public_path__ + "static/media/0014.b47adb89.svg";